const BUTTON_STYLE_BASE_OVERRIDES = {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "165%",
};

export { BUTTON_STYLE_BASE_OVERRIDES };
//# sourceMappingURL=constants.js.map
